export default __webpack_public_path__ + "a1aae2e6951e60f34926642947a36f84.svg";